/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBank = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M23.001 21v2h-22v-2zm-18-11v9h-2v-9zm12 0v9h-2v-9zm4 0v9h-2v-9zm-8 0v9h-2v-9zm-4 0v9h-2v-9zm2.553-8.894a1 1 0 0 1 .895 0l10 5C23.393 6.577 23.057 8 22 8H2C.946 8 .611 6.577 1.554 6.106zm.447 2.012L6.236 6h11.53z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBank as Bank };
